import React from 'react';

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Box,
  Button,
  Tooltip,
} from "@chakra-ui/react"

function CommonConfirmStruct({
  isOpen,
  onClose,
  cancelRef,
  onConfirmation,
  headerText,
  bodyText,
  confirmText = "Continue"
}){
  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {headerText}
            </AlertDialogHeader>

            <AlertDialogBody>
              {bodyText}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={() => {
                onConfirmation();
                onClose();
              }} ml={3}>
                {confirmText}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )

}

export function IconCommonConfirmPrompt({
  onConfirmation,
  headerText,
  bodyText,
  confirmText,
  icon,
  label,
  labelPlacement
}){
  const [isOpen, setIsOpen] = React.useState(false)
  const onClose = () => setIsOpen(false)
  const cancelRef = React.useRef()

  return (
    <>
      <Tooltip label={label} placement={labelPlacement}>
        <Box as={icon} 
          cursor="pointer"
          w={7}
          h={7}
          onClick={() => {
            setIsOpen(true);
          }}
        />
      </Tooltip>
      <CommonConfirmStruct 
        isOpen={isOpen}
        onClose={onClose}
        cancelRef={cancelRef}
        onConfirmation={onConfirmation} 
        headerText={headerText} 
        bodyText={bodyText} 
        confirmText={confirmText}
      />
    </>
  )
}

export function CommonConfirmPrompt({
  buttonText,
  colorScheme,
  onConfirmation,
  headerText,
  bodyText,
  confirmText
}){
  const [isOpen, setIsOpen] = React.useState(false)
  const onClose = () => setIsOpen(false)
  const cancelRef = React.useRef()

  return (
    <>
      <Button colorScheme={colorScheme} onClick={() => setIsOpen(true)}>
        {buttonText}
      </Button>
      <CommonConfirmStruct 
        isOpen={isOpen}
        onClose={onClose}
        cancelRef={cancelRef}
        onConfirmation={onConfirmation} 
        headerText={headerText} 
        bodyText={bodyText} 
        confirmText={confirmText}
      />
    </>
  )
}